import "../../../css/DesignSystem/AlertBanner/AlertBanner.css";
import {ReactComponent as CloseIcon} from "../../../assets/icons/Close- new.svg";

const AlertBanner = ({ type = "info", message, onClose, showClose = true }) => {
  return (
    <div className={`ds-alert ds-alert--${type}`} role="alert">
      <div className="ds-alert-message FP_Content_Semibold align-left text-black">{message}</div>
      {showClose && (
        <button
          type="button"
          className="ds-alert-close"
          onClick={onClose}
          aria-label="Close alert"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
};

export default AlertBanner;
